import { List } from 'immutable';

export const selectAlertStack = state => state.getIn(['ui', 'alertStack'], new List());
export const selectNotificationStack = state => state.getIn(['ui', 'notificationStack'], new List());
export const selectLastMenuPage = state => state.getIn(['ui', 'lastMenuPage']);
export const selectIsSettingsPage = state => state.getIn(['ui', 'isSettingsPage']);
